import { z } from "zod";

export const certificationStatusValues = ["draft", "active", "archived"] as const;
export type CertificationStatus = (typeof certificationStatusValues)[number];

// Field set WITHOUT the status default — the base for both variants. zod's
// .partial() still applies .default() values for absent keys, so a defaulted
// update schema would re-inject status:"draft" into every partial edit. The
// default lives only on create.
const certificationFieldsSchema = z.object({
  name: z.string().min(1, "Name is required").max(200),
  issuingBody: z.string().max(120).nullable().optional(),
  description: z.string().max(2000).nullable().optional(),
  status: z.enum(certificationStatusValues),
});
export const certificationCreateSchema = certificationFieldsSchema.extend({
  status: z.enum(certificationStatusValues).default("draft"),
});
export const certificationUpdateSchema = certificationFieldsSchema.partial();
export type CertificationCreateInput = z.infer<typeof certificationCreateSchema>;
export type CertificationUpdateInput = z.infer<typeof certificationUpdateSchema>;
